//action types for WEBHOOK

export const GET_ALL = "GET_ALL_WEBHOOKS";
export const GET_ALL_SUCCESS = "GET_ALL_WEBHOOKS_SUCCESS";
export const GET_ALL_FAILURE = "GET_ALL_WEBHOOKS_FAILURE";

export const GET = "GET_WEBHOOK";
export const GET_SUCCESS = "GET_WEBHOOK_SUCCESS";
export const GET_FAILURE = "GET_WEBHOOK_FAILURE";

export const ADD = "ADD_WEBHOOK";
export const ADD_SUCCESS = "ADD_WEBHOOK_SUCCESS";
export const ADD_FAILURE = "ADD_WEBHOOK_FAILURE";

export const EDIT = "EDIT_WEBHOOK";
export const EDIT_SUCCESS = "EDIT_WEBHOOK_SUCCESS";
export const EDIT_FAILURE = "EDIT_WEBHOOK_FAILURE";

export const DELETE = "DELETE_WEBHOOK";
export const DELETE_SUCCESS = "DELETE_WEBHOOK_SUCCESS";
export const DELETE_FAILURE = "DELETE_WEBHOOK_FAILURE";
